export const plasticareSurgeons : any[] = [
  {
    id: "1",
    name: "Prof. Stanley Khainga",
    title: "Board-Certified Plastic Surgeon",
    specialization: [],
    image: "https://raw.githubusercontent.com/ranger-rango/plasticare-hub-frontend/refs/heads/main/src/assets/images/stanley-khainga.jpg",
    alt: "Prof. Stanley Khainga, board certified plastic surgeon",
    yearsOfExperience: 25,
    education: [
    {
      degree: "Doctor of Medicine (M.D.)",
      institution: "Harvard Medical School",
      year: 2005,
      description: "Graduated with honors, specializing in plastic and reconstructive surgery"
    },
    {
      degree: "Plastic Surgery Residency",
      institution: "Johns Hopkins Hospital",
      year: 2011,
      description: "Completed comprehensive training in aesthetic and reconstructive procedures"
    },
    {
      degree: "Fellowship in Facial Plastic Surgery",
      institution: "Mayo Clinic",
      year: 2012,
      description: "Advanced training in facial aesthetic procedures and reconstruction"
    }],

    certifications: [],

    awards: [],

    philosophy: "I believe in enhancing natural beauty while maintaining facial harmony. My approach combines surgical precision with artistic vision to create results that look natural and feel authentic. Every patient deserves personalized care that respects their unique features and aesthetic goals.",
    videoIntroUrl: "https://example.com/dr-chen-intro.mp4",
    consultationAvailable: true,
    featuredProcedures: [],

    patientTestimonials: [
    {
      id: "t1",
      patientName: "Jennifer M.",
      patientImage: "https://img.rocket.new/generatedImages/rocket_gen_img_129550054-1764676126849.png",
      patientAlt: "Jennifer M., blonde woman in her 40s with natural makeup smiling warmly at camera",
      procedure: "Facelift",
      rating: 5,
      comment: "Dr. Chen transformed not just my appearance but my confidence. Her attention to detail and caring approach made the entire experience comfortable. The results look incredibly natural - exactly what I wanted.",
      date: "2024-01-15",
      videoUrl: "https://example.com/testimonial-jennifer.mp4"
    }],

    beforeAfterGallery: [
    {
      id: "ba1",
      procedure: "Rhinoplasty",
      beforeImage: "https://img.rocket.new/generatedImages/rocket_gen_img_19ebb389e-1765003959194.png",
      beforeAlt: "Before rhinoplasty - profile view of woman with prominent nasal bridge in clinical setting",
      afterImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1e3c616b4-1765003960787.png",
      afterAlt: "After rhinoplasty - profile view showing refined nasal contour with natural appearance",
      timeframe: "6 months post-op",
      description: "Natural refinement of nasal bridge while maintaining ethnic characteristics"
    }]

  },
  {
    id: "2",
    name: "Dr. Michael Ongas",
    title: "Board-Certified Plastic Surgeon",
    specialization: [],
    image: "https://raw.githubusercontent.com/ranger-rango/plasticare-hub-frontend/refs/heads/main/src/assets/images/DR.%20MICHAEL.jpg",
    alt: "Dr. Michael Ongas, board-certified plastic surgeon.",
    yearsOfExperience: 6,
    education: [
    {
      degree: "Doctor of Medicine (M.D.)",
      institution: "Stanford University School of Medicine",
      year: 2008,
      description: "Graduated with distinction in surgical sciences"
    },
    {
      degree: "General Surgery Residency",
      institution: "UCLA Medical Center",
      year: 2013,
      description: "Comprehensive surgical training with focus on body procedures"
    },
    {
      degree: "Plastic Surgery Fellowship",
      institution: "Cleveland Clinic",
      year: 2015,
      description: "Specialized training in body contouring and aesthetic surgery"
    }],

    certifications: [],

    awards: [],

    philosophy: "Body contouring is about helping patients achieve their ideal physique through safe, effective procedures. I focus on creating natural-looking results that enhance body proportions and boost confidence. My goal is to help patients feel comfortable and confident in their own skin.",
    videoIntroUrl: "https://example.com/dr-rodriguez-intro.mp4",
    consultationAvailable: true,
    featuredProcedures: [],

    patientTestimonials: [
    {
      id: "t3",
      patientName: "Amanda K.",
      patientImage: "https://img.rocket.new/generatedImages/rocket_gen_img_18b49529e-1764859408472.png",
      patientAlt: "Amanda K., brunette woman in her 30s with athletic build smiling outdoors",
      procedure: "Mommy Makeover",
      rating: 5,
      comment: "Dr. Rodriguez gave me my confidence back after having children. His skill and compassionate care made the entire process smooth. I feel like myself again, only better!",
      date: "2024-02-10"
    }],

    beforeAfterGallery: [
    {
      id: "ba2",
      procedure: "Tummy Tuck",
      beforeImage: "https://img.rocket.new/generatedImages/rocket_gen_img_2a03ea863-1765003977786.png",
      beforeAlt: "Before tummy tuck - frontal view showing abdominal laxity and excess skin",
      afterImage: "https://img.rocket.new/generatedImages/rocket_gen_img_11127e061-1764656058817.png",
      afterAlt: "After tummy tuck - frontal view showing toned, flat abdomen with natural contours",
      timeframe: "1 year post-op",
      description: "Complete abdominal transformation with natural-looking results"
    }]

  },
  {
    id: "3",
    name: "Dr. Evans Spanton Masitara",
    title: "Board-Certified Plastic Surgeon",
    specialization: [],
    image: "https://raw.githubusercontent.com/ranger-rango/plasticare-hub-frontend/refs/heads/main/src/assets/images/DR.%20EVANS.jpg",
    alt: "Dr. Evans Spanton Masitara, board-certified plastic surgeon.",
    yearsOfExperience: 12,
    education: [
    {
      degree: "Doctor of Medicine (M.D.)",
      institution: "University of Pennsylvania",
      year: 2011,
      description: "Graduated with honors in surgical oncology"
    },
    {
      degree: "Plastic Surgery Residency",
      institution: "Memorial Sloan Kettering Cancer Center",
      year: 2017,
      description: "Specialized training in breast reconstruction and aesthetic surgery"
    }],

    certifications: [],

    awards: [],

    philosophy: "Breast surgery is deeply personal, whether for aesthetic enhancement or reconstruction. I approach each patient with empathy and expertise, ensuring they feel heard and supported throughout their journey. My goal is to help women feel confident and comfortable in their bodies.",
    videoIntroUrl: "https://example.com/dr-thompson-intro.mp4",
    consultationAvailable: true,
    featuredProcedures: [],

    patientTestimonials: [
    {
      id: "t4",
      patientName: "Lisa P.",
      patientImage: "https://img.rocket.new/generatedImages/rocket_gen_img_17d918e2b-1763301446194.png",
      patientAlt: "Lisa P., woman in her 40s with auburn hair smiling confidently in casual attire",
      procedure: "Breast Reconstruction",
      rating: 5,
      comment: "Dr. Thompson's skill and compassion helped me through one of the most challenging times of my life. She not only restored my body but also my spirit. I'm forever grateful.",
      date: "2023-12-05"
    }],

    beforeAfterGallery: [
    {
      id: "ba3",
      procedure: "Breast Augmentation",
      beforeImage: "https://img.rocket.new/generatedImages/rocket_gen_img_174857320-1764654468594.png",
      beforeAlt: "Before breast augmentation - frontal view showing natural breast contour",
      afterImage: "https://img.rocket.new/generatedImages/rocket_gen_img_174857320-1764654468594.png",
      afterAlt: "After breast augmentation - frontal view showing enhanced, natural-looking breast volume",
      timeframe: "3 months post-op",
      description: "Natural breast enhancement with proportionate results"
    }]

  }]